import React, { useState, useEffect } from 'react'
import { Navigate, useLocation, useNavigate } from "react-router-dom";
import { Box, Button, Tab, Tabs, Typography, CircularProgress } from '@mui/material';
// import LeftSidebar from '../partials/leftSidebar';
import Row from 'react-bootstrap/Row';
import { FieldArray, Formik, Form, Field, ErrorMessage } from 'formik';
import { CheckboxWithLabel, TextField } from 'formik-material-ui';
import { array, object, number, string, boolean, ValidationError } from 'yup';
import { Form as RBFORM } from 'react-bootstrap';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Grid from "@mui/material/Grid2";
import { getMethod, putMethod, postMethod } from '../../../services/apiService';
import blueEditicon from "../../../assets/images/icon/blue-editicon.svg"
import { ToastContext, useToastContext } from "../../../context/toastContext";
import { clearStorageAndCookies, getUserPriority } from '../../../services/authService';
import { PROFILE_TYPE } from '../../../helper/globalConstant';

interface OrderDetailTabOneProps {
    isEditable: boolean;
}
interface OrderDetail {
    id: number;
    productName: string;
    quantity: number;
    createdAt: string;
    orderRef: string;
    orderId: string;
    orderName: string;
}
function OrderDetailTabOne() {

    const { setToast } = useToastContext() as ToastContext;

    const navigate = useNavigate();

    const [initialValues, setInitialValues] = useState({
        createdOn: "",               // Created on
        orderRef: "",          // Order Reference
        orderId: "",          // Customer Name
        orderName: ""

    });

    const location = useLocation();
    const { order, siteOrderId  } = location.state || {};
    // console.log(order.vSiteOrder.orderId)
    // const [orderData, setOrderData] = useState([])
    // const [orderData, setOrderData] = useState<Order[]>([]); // Array of Order objects

    const [activeTab, setActiveTab] = useState(0);
    const [isEditable, setIsEditable] = useState(false);
    const userPriority = getUserPriority();

    const [confirmationModalOpen, setConfirmationModalOpen] = useState(false);
    const [confirmationMultiDelete, setConfirmationMultiDelete] = useState(false);
    const [isDeleting, setIsDeleting] = useState(false);
    const [orderDetail, setOrderDetail] = useState<any | null>(null);
    const handleToggleEdit = () => {
        setIsEditable((prevState) => !prevState);
    };

    const handleDelete = () => {
        setConfirmationModalOpen(true)
        console.log("delete")
    }

    useEffect(() => {
        fetchOrderDetail();
    }, []);



    const fetchOrderDetail = async () => {
        const priority = getUserPriority();
        const isPartnerOrder = (priority === PROFILE_TYPE.SUPER_ADMIN || priority === PROFILE_TYPE.DISTRIBUTOR);

        let resp;
        const hasValidSiteOrderId = (typeof siteOrderId === 'string' && siteOrderId) || (Array.isArray(siteOrderId) && siteOrderId.length > 0 ? siteOrderId[0] : undefined);
        const targetOrderId = order?.partnerOrderId || order?.vPartnerOrder?.partnerOrderId || order?.vPartnerOrder?.orderId || order?.vSiteOrder?.orderId || order?.orderId || hasValidSiteOrderId;
        if (isPartnerOrder) {
            resp = await getMethod("partner/order/" + targetOrderId);
        } else {
            resp = await getMethod("customer/order/" + targetOrderId);
        }
        if (resp?.status === 200) {
            setOrderDetail(resp?.data?.result[0])
        } else {
            setToast(resp?.data?.message, "error");
        }
    }

    function convertTimestampToDate(timestamp: any): string {
        if (!timestamp) return "";
        const formattedDate = new Date(timestamp).toLocaleString();
        return formattedDate.replace(',', ',');
    }

    useEffect(() => {
        if (orderDetail) {
            const priority = getUserPriority();
            const isPartnerOrder = (priority === PROFILE_TYPE.SUPER_ADMIN || priority === PROFILE_TYPE.DISTRIBUTOR);
            const detailObj = isPartnerOrder ? (orderDetail?.vPartnerOrder || orderDetail?.partnerOrder || orderDetail) : orderDetail;
            setInitialValues({
                createdOn: convertTimestampToDate(detailObj?.createdAt) || "", 
                orderRef: detailObj?.partnerOrderRef || detailObj?.orderRef || "",
                orderId: detailObj?.partnerOrderId || detailObj?.orderId || "",
                orderName: detailObj?.partnerOrderName || detailObj?.orderName || ""
            });
        }
    }, [orderDetail])

    return (

        <Formik initialValues={initialValues}
            enableReinitialize={true} // Enable reinitialization
            validationSchema={object({
                orderName: string().trim().optional(),
                orderRef: string().trim().optional(),
            })}

            onSubmit={async (values, { setSubmitting }) => {
                console.log('Form values', values);
                const priority = getUserPriority();
                const isPartnerOrder = (priority === PROFILE_TYPE.SUPER_ADMIN || priority === PROFILE_TYPE.DISTRIBUTOR);

                let payload: any;
                let resp;
                if (isPartnerOrder) {
                    payload = {
                        "partnerOrderId": values.orderId,
                        "partnerOrderName": values.orderName,
                        "partnerOrderRef": values.orderRef,
                        "data": orderDetail?.data || orderDetail?.vPartnerOrder?.data || orderDetail?.partnerOrder?.data || []
                    }
                    resp = await postMethod("partner/order/update", payload);
                } else {
                    payload = {
                        "orderRef": values.orderRef,
                        "orderId": values.orderId,
                        "orderName": values.orderName
                    }
                    resp = await putMethod("customer/order", payload);
                }
                if (resp?.status === 200) {
                    setToast(resp?.data?.message, "success");
                    setIsEditable((prevState) => !prevState);
                } else {
                    setToast(resp?.data?.message, "error");
                }
            }}
        >

            {({ values, errors, isSubmitting, isValid, resetForm }) => (
                <React.Fragment>
                    <ToastContainer />


                    <Form autoComplete="off">
                        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 0, mb: 2 }}>

                            {isEditable &&
                                <Button type="submit" sx={{ backgroundColor: 'transparent', border: '1px solid #0B4A62', paddingInline: '16px', paddingBlock: '8px', borderRadius: '30px', cursor: 'pointer', color: '#0699CE', fontSize: '14px', fontWeight: 500, mr: 2, textTransform: "none" }} >
                                    Save Changes
                                </Button>
                            }
                            {activeTab != 2 && userPriority !== PROFILE_TYPE.SUPER_ADMIN && <Box
                                onClick={() => {
                                    if (isEditable) {
                                        resetForm();
                                    }
                                    handleToggleEdit();
                                }}
                                sx={{
                                    backgroundColor: 'transparent',
                                    border: `${isEditable ? '0px solid #0B4A62' : '1px solid #0B4A62'}`,
                                    paddingInline: '16px',
                                    paddingBlock: '12px',
                                    borderRadius: '30px',
                                    cursor: 'pointer',
                                    color: '#0699CE',
                                    fontSize: '14px',
                                    fontWeight: 500,
                                }}
                            >
                                {isEditable ? 'Cancel' : (
                                    <>
                                        <img src={blueEditicon} alt="edit" />
                                        &nbsp;&nbsp; Edit
                                    </>
                                )}
                            </Box>}


                        </Box>
                        <Row className="mb-3">
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Order Name</RBFORM.Label>
                                        <Field
                                            name="orderName"
                                            type="text"
                                            placeholder="Order Name"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Order Reference</RBFORM.Label>
                                        <Field
                                            name="orderRef"
                                            type="text"
                                            placeholder="Order Reference"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: !isEditable,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>
                                <Grid size={{ xs: 12, md: 4 }}>
                                    <RBFORM.Group>
                                        <RBFORM.Label className="label">Created on</RBFORM.Label>
                                        <Field
                                            name="createdOn"
                                            type="text"
                                            placeholder="Created on"
                                            component={TextField}
                                            className="inputC"
                                            InputProps={{
                                                readOnly: true,
                                            }}
                                        />
                                    </RBFORM.Group>
                                </Grid>


                            </Grid>

                        </Row>

                    </Form>

                </React.Fragment>
            )}
        </Formik>

    )
}

export default OrderDetailTabOne